import React, { useReducer, useEffect } from "react";
import { GlobalContext, initialState } from "./globalContext";
import { useTranslations } from "./utils/i18n";
import "./styles/main.scss";
import AddressForm from "./components/AddressForm";
import NewsletterForm from "./components/NewsletterForm";
import ResultCard from "./components/ResultCard";
import LoadingTruck from "./components/LoadingTruck";
import { initGTM } from "./utils/googleTagManagerInit";

export default function AppComponent() {
  const [store, updateStore] = useReducer((prev, next) => {
    return { ...prev, ...next };
  }, initialState);

  /** Ripristina tutto allo stato iniziale */
  const resetStore = () => {
    updateStore({
      ...initialState,
      language: store.language,
      focusAddressInput: true
    });
  };

 // Ottieni le traduzioni basate sulla lingua corrente
  const t = useTranslations(store.language);



  useEffect(() => {
    //console.log("=== LANGUAGE DETECTION ===");
    //console.log("Timestamp:", new Date().toLocaleTimeString());

    const normalizeLang = (value) => {
      if (!value) return null;
      const s = String(value).trim().toLowerCase();
      // Accept: en, it, EN, IT, en_GB, it-IT, etc.
      const two = s.slice(0, 2);
      if (two === 'en' || two === 'it') return two;
      return null;
    };

    // 1) Backward-compatible: query param (?lang=en)
    const url = new URL(window.location.href);
    const langParam = url.searchParams.get('lang');

    // 2) WordPress language in path (e.g. /en/...)
    const firstPathSegment = window.location.pathname
      .split('/')
      .filter(Boolean)[0];

    // 3) Provided by ReactPress via wp_localize_script (if enabled)
    const wpLang = window.reactPress?.wp?.lang;

    // 4) HTML lang attribute (often set by WPML/Polylang)
    const htmlLang = document.documentElement?.lang;
    
    //console.log("URL completo:", window.location.href);
    //console.log("Parametri URL:", window.location.search);
    //console.log("Parametro lang:", langParam);

    const language =
      normalizeLang(langParam) ||
      normalizeLang(firstPathSegment) ||
      normalizeLang(wpLang) ||
      normalizeLang(htmlLang) ||
      'it';
    //console.log("Lingua rilevata:", language);

    // Debug aggiuntivo
    const referrer = document.referrer;
    //console.log("Referrer:", referrer);

    // Salva anche in localStorage per debug
    localStorage.setItem(
      "debug-language",
      JSON.stringify({
        language,
        langParam,
        firstPathSegment,
        wpLang,
        htmlLang,
        urlComplete: window.location.href,
        referrer,
        timestamp: new Date().toISOString(),
      })
    );

    updateStore({ language });
  }, []);


  function isProdEnvironment() {
    const prodOrigin = 'https://www.fibercop.com';
    const referrer = document.referrer;

    try {
      if (referrer) {
        const origin = new URL(referrer).origin;
        //console.log('[isProdEnvironment] extracted origin:', origin);
        if (origin === prodOrigin) {
         //console.log('[isProdEnvironment] MATCH: origin corrisponde a prodOrigin');
          return true;
        } else {
           //console.log('[isProdEnvironment] NO MATCH: origin non corrisponde a prodOrigin');
        }
      } else {
         //console.log('[isProdEnvironment] referrer non presente');
      }
    } catch (e) {
       console.warn('[isProdEnvironment] Errore parsing referrer:', e);
    }
    return false;

  }

  function isCollEnvironment() {
    const collOrigin = 'https://collwww.fibercop.it';
    const referrer = document.referrer;
    //console.log('[isCollEnvironment] referrer:', referrer);
    try {
      if (referrer) {
        const origin = new URL(referrer).origin;
        //console.log('[isCollEnvironment] extracted origin:', origin);
        if (origin === collOrigin) {
          //console.log('[isCollEnvironment] MATCH: origin corrisponde a collOrigin');
          return true;
        } else {
          //console.log('[isCollEnvironment] NO MATCH: origin non corrisponde a collOrigin');
        }
      } else {
         //console.log('[isCollEnvironment] referrer non presente');
      }
    } catch (e) {
       console.warn('[isCollEnvironment] Errore parsing referrer:', e);
    }
    return false;
  }


  //GOOGLE TAG MANAGER
  useEffect(() => {
    const gtmEnabled = process.env.REACT_APP_GTM_ENABLED === "true";
    let gtmId = null;
    let gtmUrl = null;

    if (isProdEnvironment()) {
      //console.log('[GTM] Ambiente PROD rilevato');
      gtmId = process.env.REACT_APP_GTM_ID_PROD;
      gtmUrl = process.env.REACT_APP_GTM_SERVER_URL_PROD;
      //console.log('[GTM] gtmId:', gtmId);
      //console.log('[GTM] gtmUrl:', gtmUrl);
    } else if (isCollEnvironment()) {
      //console.log('[GTM] Ambiente COLL rilevato');
      gtmId = process.env.REACT_APP_GTM_ID_COLL;
      gtmUrl = process.env.REACT_APP_GTM_SERVER_URL_COLL;
      //console.log('[GTM] gtmId:', gtmId);
      //console.log('[GTM] gtmUrl:', gtmUrl);
    } else {
      //console.log('[GTM] Nessun ambiente GTM rilevato, non verrà inizializzato');
    }

    if (gtmEnabled && gtmId && gtmUrl) {
      //console.log('[GTM] Inizializzo GTM con id e url:', gtmId, gtmUrl);
      const alreadyLoaded =
        Boolean(window.google_tag_manager) ||
        Boolean(document.querySelector(`script[src*="gtm.js?id=${gtmId}"]`));

      if (!alreadyLoaded) {
        initGTM({ gtmId, serverUrl: gtmUrl });
      }
    } else {
      //console.log('[GTM] GTM non abilitato o dati mancanti:', { gtmEnabled, gtmId, gtmUrl });
    }
  }, []);

  return (
    <GlobalContext.Provider value={{ store, updateStore, resetStore, t }}>
      {/* Se non è ancora stata fatta una verifica → mostra la home */}
      {store.isLoading && (
        <div className="global-loading-overlay">
          <LoadingTruck />
        </div>
      )}

      {store.responseStatus === null && (
        <>
          <div className="hero">
            <div className="hero-overlay"></div>
            <div className="hero-content">
              <h1 className="hero-title">
                {t.heroTitleOne} <br />
                {t.heroTitleTwo} <br />
                {t.heroTitleThree}
              </h1>
              <AddressForm />
              <NewsletterForm />
            </div>
            {/* 
            <img
              src={DownArrowWhite}
              alt={"arrow down"}
              className="down-arrow"
            />
            
            */}
          </div>
        </>
      )}

      {/* Risultato (fuori da hero-content e overlay) */}
      {store.responseStatus !== null && (
        <div className="result-container">
          <div className="breadcrumb">
            <p>
              <span
                className="breadcrumb-link"
                onClick={resetStore}
                style={{ cursor: "pointer" }}
              >
                Home
              </span>{" "}
              <span className="breadcrumb-separator">&gt;&gt;</span> Marketspace
            </p>
          </div>
          <div className="result-wrapper">
            <ResultCard
              variant={store.responseStatus}
              address={store.selectedAddress}
            />
          </div>
        </div>
      )}
    </GlobalContext.Provider>
  );
}
